module.exports = __webpack_public_path__ + "img/palmar-resort-2.0a8d34b4.jpg";